export default "__VITE_PUBLIC_ASSET__adfbd582__"